export default __webpack_public_path__ + "static/media/chaqueta-rockera-hombre.fdfe3119.png";